import React, { Component } from 'react';
import { Autocomplete, TextField } from "@mui/material";
import { withStyles } from "@material-ui/core/styles";
import { withNamespaces } from 'react-i18next';
import Axios from 'axios';
import Fade from "react-reveal/Fade";
import { TextArea } from "semantic-ui-react";
import { Services } from '../../Services';
import Checkbox from '@mui/material/Checkbox';
import $ from 'jquery';
import CustomPopupIcon from '../../add/customPopupIcon';
// const rest = new restService();

const useStyles = (theme) => ({
  textfield: {
    "& .MuiInputBase-input.MuiAutocomplete-input": {
      fontSize: 12,
      color: "#000a2e"
    }
  },
  datefield: {
    "& .MuiInput-input.MuiInputBase-input": {
      fontSize: 12,
      color: "#000a2e"
    }
  },
  searchLabel: {
    fontSize: 12,
  },
  popupIndicator: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  },
  popupIndicatorOpen: {
    "& path": {
      d: "path('M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z')",
    },
  }
});

class Proveedor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suppliers: this.props.suppliers,
      customerSelected: "",
      suppliersArray: [],
      supplierSelected: null,
      direccionProveedor: "",
      contactSelected: null,
      contactsArray: [],
      supplierInfo: {},
      contactInfo: {},
      contactInfoVisual: {},
      contacts: [],
      found: null,
      foundContact: null,
      isLoaded: false,
      firstContact: true,
      errors: {},
      info: this.props.info ? this.props.info : {},
      isEdit: this.props.isEdit ? this.props.isEdit : false,
      checkedAddress: false
    };
  }


  componentDidMount = () => {
    let { isLoaded, info, supplierSelected, contactSelected, direccionProveedor, checkedAddress, suppliers } = this.state;
    if (!isLoaded) {
      let checked = !info.CheckPickupAddress || info.CheckPickupAddress == 0 ? false : true;
      this.setState({
        supplierSelected: info && info.SupplierId ? {
          value: info.SupplierCode, label: info.SupplierName,
          subLabel: info.Address
        } : supplierSelected,
        contactSelected: info && info.SupplierContactId ? { value: info.SupplierContactId, label: info.SupplierContact } : contactSelected,
        checkedAddress: info && info.CheckPickupAddress ? checked : checkedAddress,
        direccionProveedor: info && info.PickupAddress ? info.PickupAddress : direccionProveedor,
        errors: this.props.errors,
        customerSelected: info && info.CustomerId ? info.CustomerId : ""
      });
    }
    if (info && info.SupplierId) {
      if (info.SupplierContactId) {
        this.getContactsLabel();
      }

      if (suppliers && suppliers.length > 0) {
        this.buildArraySuppliers();
      }
      this.validateComponentHeight();
    }
  }

  componentWillReceiveProps = (nextProps) => {

    let { customerSelected, isLoaded, info, supplierSelected, contactSelected,
      direccionProveedor, checkedAddress, supplierInfo, contactInfo, contactsArray } = this.state;
    let infoNext = nextProps.info;
    if (!isLoaded) {
      this.setState({
        errors: nextProps.errors,
        info
      });
    }
    let resetFlag = false;
    if (nextProps.CustomerId != customerSelected) {
      resetFlag = true;
      customerSelected = nextProps.CustomerId;
    }

    if (nextProps.isEdit) {
      let checked = !infoNext || !infoNext.CheckPickupAddress || infoNext.CheckPickupAddress == 0 ? false : true;

      this.setState({
        isEdit: nextProps.isEdit,
        supplierSelected: resetFlag ? null : supplierSelected,
        contactSelected: resetFlag ? null : contactSelected,
        contactInfo: resetFlag ? {} : contactInfo,
        supplierInfo: resetFlag ? {} : supplierInfo,
        contactsArray: resetFlag ? [] : contactsArray,
        customerSelected,
        suppliers: nextProps.suppliers,
        checkedAddress: resetFlag ? false : infoNext && infoNext.CheckPickupAddress ? checked : checkedAddress,
        direccionProveedor: resetFlag ? "" : infoNext && infoNext.PickupAddress ? infoNext.PickupAddress : direccionProveedor,
        errors: this.props.errors
      }, () => {
        if (this.state.info.SupplierContactId) {
          this.getContactsLabel();
        }
        this.buildArraySuppliers();
        this.validateComponentHeight();
      });
    }
  }


  buildArraySuppliers = () => {
    const { suppliers } = this.state;
    let array = [];
    suppliers.forEach((e) => array.push({ value: e.entityCode, label: e.entityName, subLabel: e.address }));
    this.setState({ suppliersArray: array }, () => this.setFirstOrderValues());
  }

  setFirstOrderValues = () => {
    let { supplierSelected, suppliersArray, found } = this.state;
    if (supplierSelected && supplierSelected.value != "" && !found) {
      let found = suppliersArray.find((element) => element.value === supplierSelected.value);
      if (found) this.handleChangeSelect(null, supplierSelected);
      this.setState({
        found
      });
    }
  }

  handleChangeSelect = (evt, data) => {
    let { suppliers, supplierInfo, info } = this.state;
    if (data) {
      supplierInfo = suppliers.find((sup) => { return sup.entityCode == data.value })
      supplierInfo.Address = this.generateAddress(supplierInfo);

      this.setState({
        supplierSelected: data, selected: data.value,
        contactInfo: {},
        supplierInfo,
        direccionProveedor: this.state.checkedAddress ? supplierInfo.Address : this.state.direccionProveedor,
        contactSelected: null,
      },
        this.buildSupplierDetail(data.value, supplierInfo.Address))
    }
    else {
      this.setState({
        supplierSelected: null,
        contactsArray: [],
        contacts: [],
        contactSelected: null,
        contactInfo: {},
        supplierInfo: {},
        direccionProveedor: ""

      }, () => {
        this.props.sendProps({
          stateField: 'SupplierId',
          id: ''
        });
        this.props.sendProps({
          stateField: 'SupplierContactId',
          id: ''
        });
        this.props.sendProps({
          stateField: "PickupAddress",
          id: ""
        })
      });
    }
    this.validateComponentHeight();
  }

  validateComponentHeight = () => {
    let maxHeight = 0;
    $(".direccion-check").each((index, val) => {
      maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
    });
    $(".direccion-check").css("min-height", maxHeight);

    maxHeight = 0;
    $(".info-general-div").each((index, val) => {
      maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
    });
    $(".info-general-div").css("min-height", maxHeight);

    maxHeight = 0;
    $(".div-contacto").each((index, val) => {
      maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
    });
    $(".div-contacto").css("min-height", maxHeight);

    maxHeight = 0;
    $(".div-entidad").each((index, val) => {
      maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
    });
    $(".div-entidad").css("min-height", maxHeight);


    maxHeight = 0;
    $(".contact-name").each((index, val) => {
      maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
    });
    $(".contact-name").css("min-height", maxHeight);

    maxHeight = 0;
    $(".contact-phone").each((index, val) => {
      maxHeight = $(val).height() > maxHeight ? $(val).height() : maxHeight;
    });
    $(".contact-phone").css("min-height", maxHeight);
  }

  generateAddress = (supplier) => {
    return supplier.address;
  }
  generateAddressEdit = () => {
    let { info } = this.state;
    return info.SupplierAddress;
  }



  buildSupplierDetail = (id, address) => {
    const { suppliers } = this.state;
    let index = suppliers.findIndex(x => x.entityCode === id);
    this.setState({ supplierSelected: suppliers[index] }, () => {
      this.props.sendProps({ stateField: 'SupplierId', id: this.state.supplierSelected.value })
      this.props.sendProps({ stateField: "PickupAddress", id: this.state.direccionProveedor })
      this.props.sendProps({
        stateField: 'SupplierContactId',
        id: ''
      });
    });
    this.getContacts(suppliers[index].entityCode);

  }


  getContacts = (id) => {
    let { contacts, suppliers } = this.state;
    suppliers.map((supplier) => {
      if (supplier.entityCode == id) {
        contacts = supplier.contacts == "" ? [] : supplier.contacts;
      }
    })
    this.setState({
      contacts
    }, () => {
      this.buildArrayContacts()
    });
  }
  getContactsLabel = () => {
    let { info } = this.state;
    Axios.get(`${Services.ORDEN_SERV.path}orden/contactInfo/${info.SupplierContactId}`).then((data) => {
      let contact = data.data.data;
      this.setState({
        contactInfoVisual: contact ? contact : {}
      }, () => {

        this.validateComponentHeight();
      });
    }).catch((error) => {
      console.error(error);
    });


  }

  buildArrayContacts = () => {
    const { contacts } = this.state;
    let array = [];
    contacts.forEach((e) => array.push({ value: e.contactCode, label: e.name }));
    this.setState({ contactsArray: array }, () => this.setFirstOrderValuesContacts());

  }


  setFirstOrderValuesContacts = () => {
    let { contactSelected, info, firstContact } = this.state;
    if (info && info.SupplierCodeEPContact && info.SupplierCodeEPContact != "" && firstContact) {

      contactSelected = { value: info.SupplierCodeEPContact, label: info.SupplierContact }
      this.setState({ contactSelected, firstContact: false }, () => {
        this.handleChangeSelectContact(null, contactSelected);
      })
    }




  }


  handleChangeSelectContact = (evt, data) => {
    let { contactInfo, contacts } = this.state;
    if (data) {
      contactInfo = contacts.find((cont) => { return cont.contactCode == data.value })

      this.setState({ contactInfo, contactSelected: data }, () => {
        this.props.sendProps({ stateField: 'SupplierContactId', id: data.value });
      });
    }
    else this.setState({ contactSelected: null, contactInfo: {} }, () => {
      this.props.sendProps({ stateField: 'SupplierContactId', id: '' });
    });
    this.validateComponentHeight();
  }

  handleChange = (name, isEdit) => (event) => {
    let { direccionProveedor } = this.state;
    direccionProveedor = event.target.value;
    this.setState({ direccionProveedor }, this.props.sendProps({ stateField: name, id: direccionProveedor }));
  };

  handleChangeCheck = (event) => {
    let { supplierInfo, direccionProveedor } = this.state;
    let checked = event.target.checked
    let address = event.target.checked ? supplierInfo.Address : "";
    direccionProveedor = address;
    this.setState({ checkedAddress: checked, direccionProveedor },
      () => {
        this.props.sendProps({ stateField: "CheckPickupAddress", id: checked });
        this.props.sendProps({ stateField: "PickupAddress", id: direccionProveedor })
      });
  }
  render() {
    const { suppliersArray, supplierInfo, contactInfo, supplierSelected, contactsArray, contactSelected, direccionProveedor } = this.state;

    const { classes } = this.props;

    return (
      <div>
        {
          this.state.isEdit ?
            <div className="row" style={{ marginBottom: "15px" }}>
              <div className="col-md-12">
                <span className='bold-euro' >
                  {this.props.t("select_shipper_info")}
                </span>
              </div>
            </div>
            :
            false
        }

        <div className="row div-entidad" style={{ marginBottom: "20px" }}>
          {this.state.isEdit ?
            <div className="col-xs-12 col-md-12 col-lg-12">
              <span className='bold-euro' >
                {this.props.t("shipper")}</span>
              <span style={{ color: "#ff0000" }}>*</span>
              <Autocomplete
                closeText={false}
                openText={false}
                id="SupplierCode"
                name="select-contact"
                className='input-euro'
                size="small"
                ListboxProps={{
                  sx: { fontSize: 12 },
                }}
                sx={{
                  '& .MuiAutocomplete-input, & .MuiInputLabel-root': {
                    fontSize: 12,
                  },
                }}
                getOptionLabel={(option) => (option.label)}
                renderOption={(props, option, value) => {
                  props.key = option.key;
                  return <div {...props}>
                    {
                      option.subLabel && option.subLabel != "" ?
                        <div className="row">
                          <div className="col-12">{option.label}</div>


                          <div className="col-12">
                            <label style={{ opacity: ".5" }}>{option.subLabel}</label> </div>


                        </div>
                        :
                        <span>{option.label}</span>
                    }
                  </div>
                }
                }
                filterOptions={(options, event) => {
                  let filteredOptions = options.filter((opt) => {
                    return event.inputValue == "" ||
                      opt.label.toLowerCase().includes(event.inputValue.toLowerCase())
                  })
                  return filteredOptions;
                }}
                // classes={{
                //   clearIndicatorDirty: classes.clearIndicator,
                //   popupIndicator: classes.popupIndicator,
                //   popupIndicatorOpen: classes.popupIndicatorOpen,
                // }}
                popupIcon={<CustomPopupIcon />}
                options={suppliersArray ? suppliersArray : []}

                onChange={this.handleChangeSelect}
                value={supplierSelected}

                renderInput={(params) => {
                  params.inputProps.value = supplierSelected && supplierSelected.label ?
                    supplierSelected.label : params.inputProps.value;
                  return <TextField
                    {...params}
                    variant="standard"

                  />
                }}
              />
            </div> :
            <div className="col-xs-12 col-md-12 col-lg-12">
              <div style={{ marginBottom: "5px" }}>
                <span className='bold-euro'>
                  {this.props.t("shipper")}</span>
              </div>
              <div>
                <span className='label-euro'>{this.state.info.SupplierName}</span>
              </div>
            </div>}


        </div>
        <div className="row div-contacto" style={{ marginBottom: "20px" }} >
          {this.state.isEdit ?
            <div className="col-md-12">
              <span className='bold-euro'>{this.props.t("contact")}</span>
              <Autocomplete
                closeText={false}
                openText={false}
                id="SupplierContactId"
                name="select-contact"
                size="small"
                className='input-euro'
                // freeSolo
                options={contactsArray ? contactsArray : []}
                getOptionLabel={(option) => (option.label)}
                onChange={this.handleChangeSelectContact}
                value={contactSelected}
                ListboxProps={{
                  sx: { fontSize: 12 },
                }}
                sx={{
                  '& .MuiAutocomplete-input, & .MuiInputLabel-root': {
                    fontSize: 12,
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="standard"

                  />)}
              />

            </div> :
            <div className="col-md-12">
              <div style={{ marginBottom: "5px" }}>
                <span className='bold-euro'>{this.props.t("contact")}</span>
              </div>
              <div>
                <span className='label-euro'>{this.state.info.SupplierContact}</span>
              </div>
            </div>}

        </div>
        <div className='row '>
          {/* <div className='info-general-div' style={{ display: "flex", alignItems: "center", width: "100%" }}> */}
          <div className="col-xs-2 col-md-2 col-lg-2 d-flex align-items-center d-flex justify-content-center">
            {/* <em style={{ fontSize: "25px", marginLeft: "35%" }} className="fas fa-user mr-2"></em> */}
            <span className="icon-organizations icons-front-module"></span>
          </div>
          <div className="col-xs-10 col-md-10 col-lg-10">
            <div style={{ marginBottom: "5px" }}>
              <span className='label-euro'><b>{this.state.isEdit ? supplierInfo.entityName :
                this.state.info.SupplierName} </b></span>
            </div>
            <div style={{ marginBottom: "5px" }}>
              <span className='label-euro'>{this.state.isEdit ? supplierInfo.Address :
                this.generateAddressEdit(this.state.info)} </span>
            </div>

            <div className='contact-name' style={{ marginBottom: "5px" }}>
              <span className='label-euro'>{this.state.isEdit ? contactInfo ? contactInfo.name : "" :
                this.state.contactInfoVisual.Name}</span>
            </div>

            <div className='contact-phone' style={{ marginBottom: "5px" }}>
              <span className='label-euro'>{this.state.isEdit ? contactInfo ? contactInfo.telephone : "" :
                this.state.contactInfoVisual.Telephone} </span>
            </div>
          </div>
          {/* </div> */}
        </div>
        <div className='row direccion-check'>
          <div style={{ display: "flex", alignItems: "center", marginTop: "10px", width: "100%" }}>



            {(supplierInfo && supplierInfo.entityName) ||
              (this.state.info && this.state.info.SupplierName) ? <div className="col-md-10">
              <div className="d-flex align-items-center">

                <span className='label-euro'>{this.props.t("same_pickup")}</span>
                {this.state.isEdit ?
                  <Checkbox
                    style={{ marginLeft: "5px",color: "#000a2e" }}
                    onChange={this.handleChangeCheck}
                    color="primary"
                    disabled={!this.state.isEdit}
                    checked={this.state.checkedAddress}
                    value={this.state.checkedAddress}

                  /> :
                  <span className='label-euro' style={{ marginLeft: "5px" }}>{this.state.checkedAddress ? this.props.t("yes") : "No"}</span>}
              </div>

            </div> : ""}

          </div>
        </div>
        <div className='row'>

          <div style={{ marginTop: "15px" }} className="col-md-12 col-12 col-lg-12 col-sm-12" key={"proveedorDir"}>
            <Fade left opposite>
              {" "}
              <span>
                <label className='bold-euro'>
                  {this.props.t("pickup_address")}

                  {this.state.isEdit ?
                    <span style={{ color: "#ff0000" }}>*</span> : false
                  }

                </label>
              </span>
            </Fade>
            <div style={{ display: "flex", alignItems: "center" }}>
              {!this.state.isEdit ?
                <span className='label-euro'>{direccionProveedor} </span> :
                this.state.checkedAddress ?
                  <span className='label-euro'>{direccionProveedor} </span> : <TextArea
                    required={false}
                    className='custom-textarea'
                    placeholder={this.props.t("address")}
                    disabled={!this.state.isEdit}
                    value={direccionProveedor}
                    style={{ width: "100%" }}
                    onChange={this.handleChange("PickupAddress", false)}
                  />
              }
            </div>

          </div>
        </div>
      </div >
    );
  }
}

export default withNamespaces()(withStyles(useStyles)(Proveedor));